import { MessageCircle } from "lucide-react";

export const WhatsAppFAB = () => {
  return (
    <a
      href="https://wa.me/6589867250?text=Hello%20Noah%2BRayn%2C%20I'd%20love%20to%20discuss%20a%20renovation."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-[0_18px_40px_-12px_rgba(37,211,102,0.65)] hover:scale-[1.03] transition-transform duration-300 nr-float"
    >
      <MessageCircle size={22} className="fill-white" />
      <span className="font-semibold text-sm hidden sm:inline">WhatsApp Us</span>
    </a>
  );
};
